import { useQuery } from "react-query";
import endpoints from "./EndPoints";
import { getInvoiceDetails, getInvoiceListFitler } from "./Services";


export const useGetInvoices= (filter:any) => {
  return useQuery(
    [endpoints.getInvoiceList,filter],
    () => getInvoiceListFitler(filter),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
};

export const useGetInvoiceDetails= (invoiceId:number) => {
  return useQuery(
    [endpoints.getInvoiceList,invoiceId],
    () => getInvoiceDetails(invoiceId),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
};

